import { Button, Typography } from '@material-ui/core';
import * as React from 'react';
import InsertLinkOutlinedIcon from '@material-ui/icons/InsertLinkOutlined';
import { LocationLanguageContextType, SectionFieldContainerProps } from 'typings';
import { useStaticQuery, graphql } from 'gatsby';
import useLinkFormStyles from '../../styles/LinkForm';
import FieldTitle from './FieldTitle';
import { LocationLanguageContext } from '../../contexts/LocationLanguageContext';
import { Languages } from '../../utils/getAllSupportedLanguages';

const LinkFormsMobile: React.FC<SectionFieldContainerProps> = (linkFormsProps) => {
  const classes = useLinkFormStyles();
  const { sectionFieldDetails } = linkFormsProps;
  const { name, isMandatory } = sectionFieldDetails;

  const data = useStaticQuery(
    graphql`
      query LinkFormMobileQuery {
        allStrapiTemplatePage {
          nodes {
            LinkFormLabel
            locale
          }
        }
      }
    `
  );

  const locationLanguage = React.useContext<LocationLanguageContextType | null>(LocationLanguageContext);
  const language: string = locationLanguage?.language ?? Languages.English;
  const templatePage = data.allStrapiTemplatePage.nodes.find((x: any) => x.locale === language);
  return (
    <>
      <FieldTitle name={name} isMandatory={isMandatory} />
      <Button variant='contained' className={classes.linkForm}>
        <Typography variant='caption' className={classes.mobileText}>
          {templatePage.LinkFormLabel}
        </Typography>
        <InsertLinkOutlinedIcon color='primary' />
      </Button>
    </>
  );
};

export default LinkFormsMobile;
